import React from 'react';
import {ElementTrackingContextProvider} from '../../../../tracking/context/ElementTrackingContext';
import {SectionTrackingContextProvider} from '../../../../tracking/context/SectionTrackingContext';
import {GenericPromotionTracker} from '../../../../tracking/trackerComponents/GenericPromotionTracker';
import {AccountAreaIconName} from '../../../Icon/IconName';
import EmptyPageState from '../../../utilityComponents/EmptyPageState/EmptyPageState';
import {useBankDetailsTranslationContext} from '../../context/CodBankDataTranslation.context';

interface Props {
  setEditMode: (active: boolean) => void;
}
export default function EmptyState({setEditMode}: Props) {
  const {emptyBankTitle, bankDetailsCTA, emptyBankSubtitle} =
    useBankDetailsTranslationContext();

  const onSheetCTAClick = () => {
    setEditMode(true);
  };

  return (
    <SectionTrackingContextProvider>
      <ElementTrackingContextProvider>
        <GenericPromotionTracker
          name={'add_bank_data'}
          id={'add_bank_data'}
          source={'CTA' as any}
        >
          <EmptyPageState
            title={emptyBankTitle}
            subTitle={emptyBankSubtitle}
            CTAText={bankDetailsCTA}
            icon={AccountAreaIconName.IcEmptyBankdetails}
            ctaAction={{onClick: onSheetCTAClick}}
          />
        </GenericPromotionTracker>
      </ElementTrackingContextProvider>
    </SectionTrackingContextProvider>
  );
}
